import React, { useState, useEffect, createRef } from "react";
import {
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Typography,
    Button,
} from "@material-ui/core";
import classNames from "classnames";
import useStyles from "./styles.js";

const NewsCard = ({
    article: { description, publishedAt, source, title, url, urlToImage },
    i,
    activeArticle,
}) => {
    const classes = useStyles();
    const [elRefs, setElRefs] = useState([]);
    const scrollToRef = (ref) => window.scroll(0, ref.current.offsetTop - 50);

    useEffect(() => {
        // We always have 20 cards.
        // Map over each card and use the ref or create one if doesn't exists
        setElRefs((refs) =>
            Array(20)
                .fill()
                .map((_, j) => refs[j] || createRef())
        );
    }, []);

    useEffect(() => {
        if (i === activeArticle && elRefs[activeArticle]) {
            scrollToRef(elRefs[activeArticle]);
        }
    }, [i, activeArticle, elRefs]);

    return (
        <Card
            className={classNames(
                classes.card,
                activeArticle === i ? classes.activeCard : null
            )}
            ref={elRefs[i]}
        >
            <CardActionArea href={url} target="_blank">
                <CardMedia
                    className={classes.media}
                    image={
                        urlToImage ||
                        "https://www.industry.gov.au/sites/default/files/August%202018/image/news-placeholder-738.png"
                    }
                    title={title}
                />
                <div className={classes.details}>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="h2"
                    >
                        {new Date(publishedAt).toDateString()}
                    </Typography>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="h2"
                    >
                        {source.name}
                    </Typography>
                </div>
                <Typography
                    className={classes.title}
                    gutterBottom
                    variant="h5"
                    component="h2"
                >
                    {title}
                </Typography>
                <CardContent>
                    <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                    >
                        {description}
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions className={classes.cardActions}>
                <Button size="small" color="primary" href={url}>
                    Learn More
                </Button>
                <Typography variant="h5" color="textSecondary" component="h2">
                    {i + 1}
                </Typography>
            </CardActions>
        </Card>
    );
};

export default NewsCard;
